<template>
  <!--头部组件-->
  <tkui-header
    slot="header"
    center
    class="flex"
    :style="{ backgroundColor: isHeaderColor ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0)' + '!important',
      zIndex: zIndex, paddingTop: statusBarHeight + 'px !important' }"
  >
    <!--返回按钮-->
    <div slot="left-menu" v-if="isShowBack" @click="handleGoBack">
      <tkui-button class="icon" :class="{'flex-icon': backStyle}">
        <tk-icon v-if="backStyle" size="18" color="#fff">return</tk-icon>
        <tk-icon v-else size="18" :color="isHeaderColor ? '#000000' : '#fff'">{{iconName}}</tk-icon>
      </tkui-button>
    </div>
    <!--插槽-->
    <slot name="center-menu" v-if="isHeaderColor || path.includes($route.path)"></slot>
    <slot slot="right" name="right-menu"></slot>
  </tkui-header>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      path: [
        '/commodity/limitedTimeSnapping',
        '/signLottery/checkPage',
        '/itsMine/memberCenter',
        '/home/shoppingCar',
        '/itsMine/myHappyBean',
        '/order/orderConfirmation',
        '/itsMine/myClient'
      ]
    }
  },
  props: {
    isHeaderColor: {
      type: Boolean,
      required: false
    },
    zIndex: {
      type: Number,
      required: false,
      default: 8
    },
    isShowBack: {
      type: Boolean,
      required: true
    },
    backStyle: {
      type: Boolean,
      default: false,
      required: true
    },
    iconName: {
      type: String,
      default: 'return',
      required: true
    }
  },
  computed: {
    ...mapState(['statusBarHeight'])
  },
  methods: {
    /**
     * 如果不绑定方法只执行返回操作
     * @date: 2020/3/9
     */
    handleGoBack () {
      this.$listeners.watchBack !== undefined ? this.$listeners.watchBack() : this.$back()
    }
  }
}
</script>

<style lang="scss" scoped>
  /*头部样式*/
  .flex {
    border-bottom: none !important;
    padding: 20px 20px 0 15px !important;
    background: #fff;
    position: absolute;
    top: 0;
    height: 70px;
    .flex-icon {
      width: 30px;
      height: 30px;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
    }
  }
</style>
